import { useMemo } from "react";

import { useIdleSession } from "@/hooks/useIdle";

export default function Idle({ onOpenMural, timeout = 30000 }) {
  const onExpire = () => {
    onOpenMural();
  };

  const IDLE_CONFIG = useMemo(
    () => ({
      timeout,
      onExpire,
    }),
    [timeout]
  );

  const { reset } = useIdleSession(IDLE_CONFIG);

  return null;
}
